import {
    Injectable
} from '@angular/core';
import { DatiqAppStateService } from '@dat/datiq-app/data';
import { IqRulesService } from '../iq-rules/iq-rules.service';
import { IDatiqAction, IDatiqRulesData } from '../models';

@Injectable({
    providedIn: 'root',
})
export class IqActionsService {
    // TODO: refactor to not use the DatiqAppStateService
    constructor(
        private readonly _actions: DatiqAppStateService,
        private readonly _rules: IqRulesService,
    ) {}

    fireActions(actions: IDatiqAction[]): void {
        if (!actions?.length) return;

        actions.forEach((action: IDatiqAction) => {
            this._actions.fireAction(action);
        });
    }

    fireValidActions(rules: IDatiqRulesData<IDatiqAction>[]) {
        this._rules.evaluateRules$(rules).subscribe((actions) => {
            this.fireActions(actions);
        });
    }
}
